export default "__VITE_ASSET__DQmJ8oHO__"